import { FC } from "react";

import { Translate } from "@/app/application/Translate";
import { tokens } from "@/app/application/theme";
import CrisisAlertIcon from "@mui/icons-material/CrisisAlert";
import { Button, Card, useTheme } from "@mui/material";

interface ErrorProps {
	message?: string;
	reset: () => void;
}

const ComponentError: FC<ErrorProps> = ({ message, reset }) => {
	void message;
	const theme = useTheme();
	const colors = tokens(theme.palette.mode);
	return (
		<Card
			style={{
				color: colors.redAccent[400],
				padding: ".5rem",
				backgroundColor: colors.redAccent[900],
				borderColor: colors.redAccent[400],
				borderRadius: "5px",
				display: "flex",
				flexDirection: "column",
				justifyContent: "center",
				alignItems: "center",
				margin: "auto",
				gap: "1rem",
			}}
		>
			<CrisisAlertIcon sx={{ color: colors.redAccent[400] }} />
			<strong>
				<Translate String="Error.Boundary.Title">An error occurred</Translate>
			</strong>

			<Button variant="outlined" color="error" onClick={reset}>
				<Translate String="Error.Button.Refresh">Try again</Translate>
			</Button>
		</Card>
	);
};

export default ComponentError;
